module.exports = __webpack_public_path__ + "media/images/vector-38@2x-c97384d41bb9a06a61c6dac3c35bf225.png";